import React from 'react';
import Currency from '@prisjakt/ui-currency';

const PriceRange: React.FC<IPriceRangeProps> = props => {
  const { priceFrom, priceTo } = props;

  return priceFrom === priceTo ? (
    <Currency price={priceTo} />
  ) : (
    <>
      <Currency price={priceFrom} /> - <Currency price={priceTo} />
    </>
  );
};

interface IPriceRangeProps {
  priceFrom?: number;
  priceTo?: number;
}

export default PriceRange;
